import React, { Component } from 'react';
import PaymentConfigurationSettingsForm from './SettingsForm';
import { configurationComponent, configurationValues } from './methods/common';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

class SettingsDialog extends Component {

	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	renderFooter(isReadonly, t) {
		const closeBtn = <Button key='btn-close' onClick={this.props.onCancel}>{t('Common_Close')}</Button>;
		const saveBtn = <RemoteSubmitButton key='btn-save' style='success' disabled={isReadonly} formName='paymentConfiguration' label={t('Common_Save')} icon={faCheck} />;
		return [closeBtn, saveBtn];
	}

	handleSubmit(values) {
		const { onSaveConfiguration, data } = this.props;
		if (onSaveConfiguration) {
			onSaveConfiguration(data, values);
		}
	}

	dialogConfig() {
		const { t, franchisor, isReadonly, paymentOwnerType, paymentOwnerId, franchiseeId, onConfigurationUpdated, onCancel, paymentConfigurationFormValues } = this.props;
		const { method, data } = this.props;
		const configValues = configurationValues(method, data);
		const configComponent = configurationComponent(method, configValues, {
			t,
			franchisor,
			paymentConfigurationId: data && data.id,
			paymentOwnerType,
			paymentOwnerId,
			franchiseeId,
			enabled: paymentConfigurationFormValues.enabled,
			onSubmit: this.handleSubmit,
			onConfigurationUpdated		// when config data is updated from another component (GoCardless OAuth)
		});
		let showSupportTypes = data && data.paymentMethod && data.paymentMethod.supportsOneOffPayments && data.paymentMethod.supportsRecurringPayments;

		return {
			header: method ? t('PaymentMethod_Configuration_Title', { name: method }) : '',
			body: <PaymentConfigurationSettingsForm
				isReadonly={isReadonly}
				onSubmit={this.handleSubmit}
				initialValues={configValues}
				method={method}
				t={t}
				configuration={configComponent}
				showSupportTypes={showSupportTypes}
			/>,
			onHide: onCancel,
			footer: this.renderFooter(isReadonly, t)
		};
	}

	render() {
		return <Dialog config={this.dialogConfig()} show={this.props.show} t={this.props.t} />;
	}
}

export default SettingsDialog;